import {
  mediaQueries,
  size,
  RadioButton,
  Button as RawButton,
  Dropdown,
  colors,
  typography,
} from '@everlywell/leaves';
import styled from 'styled-components';

import { QuantityPicker as RawQuantityPicker } from '../QuantityPicker';

export const Legend = styled.legend<{ hideSubscription?: boolean }>`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  z-index: ${(props) => (props.hideSubscription ? '-1' : '')};
`;

export const Fieldset = styled.fieldset``;

export const Radio = styled(RadioButton)``;

export const RadioWrapper = styled.div`
  margin-bottom: ${size.lg}px;
  ${mediaQueries.forTabletVerticalUp} {
    margin-right: ${size.xl2}px;
  }

  label {
    height: unset;
  }
`;

export const ButtonsWrapper = styled.div<{ hideSubscription?: boolean }>`
  display: ${(props) => (props.hideSubscription ? 'none' : 'flex')};
  flex-direction: column;

  ${mediaQueries.forTabletVerticalUp} {
    flex-direction: row;
    min-height: ${size.xl1}px;
  }
  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    justify-content: flex-end;

    ${RadioWrapper} {
      margin-right: ${size.lg}px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  ${mediaQueries.forDesktopUp} {
    ${RadioWrapper} {
      margin-right: ${size.xl4}px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const FrequencyTrigger = styled.button`
  ${typography.buttonTextSmall}
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin-left: calc(27px + ${size.xs1}px);
  margin-top: ${size.sm}px;
`;

export const ModalContent = styled.div`
  height: calc(100vh - ${size.xl2}px);
  display: flex;
  flex-direction: column;
  padding-bottom: ${size.xs1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    height: unset;
  }
`;

export const SubscriptionModalHeader = styled.p`
  ${typography.h4Text};
  text-align: center;

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.h3Text};
  }
`;

export const FieldsetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  flex: 1;
`;

export const SubscriptionFieldset = styled.fieldset`
  margin-top: ${size.xl2}px;
`;

export const SubscriptionOption = styled.div`
  margin-bottom: ${size.xl1}px;
`;

export const Savings = styled.p`
  ${typography.captionText};
  line-height: ${size.md}px;
  margin-top: ${size.xs1}px;
  color: ${colors.red3};
  font-weight: ${typography.weight.xbold};
  margin-left: calc(27px + ${size.xs1}px);
  text-align: left;
`;

export const ModalCTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`;

export const CTA = styled(RawButton)`
  width: 100%;
  max-height: 48px;

  ${mediaQueries.forTabletVerticalUp} {
    min-width: 195px;
    max-width: max-content;
  }
`;

export const CTASubheadline = styled.p`
  ${typography.bodyTextSmall}
  font-weight: ${typography.weight.bold};
  text-align: center;
  margin-top: ${size.sm}px;

  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.md}px;
  }

  a {
    text-decoration: none;
    color: ${colors.green5};
    font-weight: ${typography.weight.bold};
  }
`;

export const ButtonAndQtyPicker = styled.div`
  display: flex;
  align-items: center;
`;

export const QuantityPicker = styled(RawQuantityPicker)`
  display: none;

  ${mediaQueries.forTabletVerticalUp} {
    display: block;
  }
`;

export const StickyPurchaseWrapper = styled.div`
  display: flex;
`;

export const MobileQuantityPicker = styled(QuantityPicker)`
  display: block;
  margin-right: ${size.md}px;
  max-width: 65px;

  ${mediaQueries.forTabletVerticalUp} {
    margin-right: ${size.lg}px;
  }

  select {
    width: 100%;
    padding: 8px 30px 12px 12px;
  }

  svg {
    right: 12px;
  }
`;

export const StickyQuantityPicker = styled(MobileQuantityPicker)`
  select {
    line-height: 1rem;
    max-height: 32px;
    max-width: 65px;
    padding: 6px 32px 6px 8px;
  }

  svg {
    top: 12px;
    right: 14px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const QtyDropdown = styled(Dropdown)`
  display: none;

  ${mediaQueries.forTabletVerticalUp} {
    display: block;
    min-width: 74px;
    margin-right: ${size.lg}px;
  }
`;

export const DesktopCTAWrapper = styled.div<{ isStickyAppearance: boolean }>`
  display: ${(props) => (props.isStickyAppearance ? 'none' : 'flex')};
  flex-direction: column;
  padding: ${size.md}px 0 ${size.xs2}px;

  ${mediaQueries.forTabletVerticalUp} {
    flex-direction: row-reverse;
    justify-content: space-between;
    padding-bottom: ${size.sm}px;
  }
  ${mediaQueries.forTabletHorizontalUp} {
    display: flex;
    padding: 0;
    flex-direction: column;
  }

  ${mediaQueries.forDesktopUp} {
    margin-top: 0;
  }
`;

export const Gradient = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${colors.white} 70%
  );
  height: ${size.xl2}px;
  position: absolute;
  top: -${size.xl2}px;
  width: calc(100% - ${size.md}px);
`;

export const StickyMobileAddToCart = styled(RawButton)`
  display: block;
  font-size: ${size.md}px;
  padding: ${size.xs2}px ${size.xs1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const SubscriptionLink = styled.a`
  ${typography.bodyTextSmall};
  display: block;
  margin-top: ${size.md}px;
  margin-left: ${size.xl1}px;
  color: ${colors.green5};
  text-decoration: none;
  font-weight: ${typography.weight.xbold};
`;
